/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as dashboardDashboardRouteImport } from './routes/(dashboard)/dashboard'
import { Route as authAuthRouteImport } from './routes/(auth)/_auth'
import { Route as dashboardDashboardIndexRouteImport } from './routes/(dashboard)/dashboard/index'
import { Route as authAuthIndexRouteImport } from './routes/(auth)/_auth/index'
import { Route as authAuthWeightLossRouteImport } from './routes/(auth)/_auth/weight-loss'
import { Route as authAuthUrgentCareRouteImport } from './routes/(auth)/_auth/urgent-care'
import { Route as authAuthUpdatePasswordRouteImport } from './routes/(auth)/_auth/update-password'
import { Route as authAuthResetPasswordRouteImport } from './routes/(auth)/_auth/reset-password'
import { Route as dashboardDashboardProgramRouteRouteImport } from './routes/(dashboard)/dashboard/$program/route'
import { Route as dashboardDashboardProgramIndexRouteImport } from './routes/(dashboard)/dashboard/$program/index'
import { Route as dashboardDashboardProgramTodosRouteImport } from './routes/(dashboard)/dashboard/$program/todos'
import { Route as dashboardDashboardProgramSettingsRouteImport } from './routes/(dashboard)/dashboard/$program/settings'
import { Route as dashboardDashboardProgramPaymentsRouteImport } from './routes/(dashboard)/dashboard/$program/payments'
import { Route as dashboardDashboardProgramEncountersRouteImport } from './routes/(dashboard)/dashboard/$program/encounters'
import { Route as dashboardDashboardProgramCalendarRouteImport } from './routes/(dashboard)/dashboard/$program/calendar'
import { Route as authAuthSuccessTypeRouteImport } from './routes/(auth)/_auth/success.$type'
import { Route as dashboardDashboardProgramTodosIndexRouteImport } from './routes/(dashboard)/dashboard/$program/todos/index'
import { Route as dashboardDashboardProgramSettingsIndexRouteImport } from './routes/(dashboard)/dashboard/$program/settings/index'
import { Route as dashboardDashboardProgramRescheduleBookingIndexRouteImport } from './routes/(dashboard)/dashboard/$program/reschedule-booking/index'
import { Route as dashboardDashboardProgramPaymentsIndexRouteImport } from './routes/(dashboard)/dashboard/$program/payments/index'
import { Route as dashboardDashboardProgramPatientsIndexRouteImport } from './routes/(dashboard)/dashboard/$program/patients/index'
import { Route as dashboardDashboardProgramEncountersIndexRouteImport } from './routes/(dashboard)/dashboard/$program/encounters/index'
import { Route as dashboardDashboardProgramCalendarIndexRouteImport } from './routes/(dashboard)/dashboard/$program/calendar/index'
import { Route as dashboardDashboardProgramTodosTabRouteImport } from './routes/(dashboard)/dashboard/$program/todos/$tab'
import { Route as dashboardDashboardProgramSettingsUserProfileRouteImport } from './routes/(dashboard)/dashboard/$program/settings/user-profile'
import { Route as dashboardDashboardProgramPaymentsTabRouteImport } from './routes/(dashboard)/dashboard/$program/payments/$tab'
import { Route as dashboardDashboardProgramEncountersTabRouteImport } from './routes/(dashboard)/dashboard/$program/encounters/$tab'
import { Route as dashboardDashboardProgramPatientsPatientIdRouteImport } from './routes/(dashboard)/dashboard/$program/patients/patient.$id'
import { Route as dashboardDashboardProgramEncountersEncounterIdRouteImport } from './routes/(dashboard)/dashboard/$program/encounters/encounter.$id'

const dashboardDashboardRoute = dashboardDashboardRouteImport.update({
  id: '/(dashboard)/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const authAuthRoute = authAuthRouteImport.update({
  id: '/(auth)/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const dashboardDashboardIndexRoute = dashboardDashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => dashboardDashboardRoute,
} as any)
const authAuthIndexRoute = authAuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => authAuthRoute,
} as any)
const authAuthWeightLossRoute = authAuthWeightLossRouteImport.update({
  id: '/weight-loss',
  path: '/weight-loss',
  getParentRoute: () => authAuthRoute,
} as any)
const authAuthUrgentCareRoute = authAuthUrgentCareRouteImport.update({
  id: '/urgent-care',
  path: '/urgent-care',
  getParentRoute: () => authAuthRoute,
} as any)
const authAuthUpdatePasswordRoute = authAuthUpdatePasswordRouteImport.update({
  id: '/update-password',
  path: '/update-password',
  getParentRoute: () => authAuthRoute,
} as any)
const authAuthResetPasswordRoute = authAuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => authAuthRoute,
} as any)
const dashboardDashboardProgramRouteRoute =
  dashboardDashboardProgramRouteRouteImport.update({
    id: '/$program',
    path: '/$program',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardProgramIndexRoute =
  dashboardDashboardProgramIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardProgramRouteRoute,
  } as any)
const dashboardDashboardProgramTodosRoute =
  dashboardDashboardProgramTodosRouteImport.update({
    id: '/todos',
    path: '/todos',
    getParentRoute: () => dashboardDashboardProgramRouteRoute,
  } as any)
const dashboardDashboardProgramSettingsRoute =
  dashboardDashboardProgramSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => dashboardDashboardProgramRouteRoute,
  } as any)
const dashboardDashboardProgramPaymentsRoute =
  dashboardDashboardProgramPaymentsRouteImport.update({
    id: '/payments',
    path: '/payments',
    getParentRoute: () => dashboardDashboardProgramRouteRoute,
  } as any)
const dashboardDashboardProgramEncountersRoute =
  dashboardDashboardProgramEncountersRouteImport.update({
    id: '/encounters',
    path: '/encounters',
    getParentRoute: () => dashboardDashboardProgramRouteRoute,
  } as any)
const dashboardDashboardProgramCalendarRoute =
  dashboardDashboardProgramCalendarRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => dashboardDashboardProgramRouteRoute,
  } as any)
const authAuthSuccessTypeRoute = authAuthSuccessTypeRouteImport.update({
  id: '/success/$type',
  path: '/success/$type',
  getParentRoute: () => authAuthRoute,
} as any)
const dashboardDashboardProgramTodosIndexRoute =
  dashboardDashboardProgramTodosIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardProgramTodosRoute,
  } as any)
const dashboardDashboardProgramSettingsIndexRoute =
  dashboardDashboardProgramSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardProgramSettingsRoute,
  } as any)
const dashboardDashboardProgramRescheduleBookingIndexRoute =
  dashboardDashboardProgramRescheduleBookingIndexRouteImport.update({
    id: '/reschedule-booking/',
    path: '/reschedule-booking/',
    getParentRoute: () => dashboardDashboardProgramRouteRoute,
  } as any)
const dashboardDashboardProgramPaymentsIndexRoute =
  dashboardDashboardProgramPaymentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardProgramPaymentsRoute,
  } as any)
const dashboardDashboardProgramPatientsIndexRoute =
  dashboardDashboardProgramPatientsIndexRouteImport.update({
    id: '/patients/',
    path: '/patients/',
    getParentRoute: () => dashboardDashboardProgramRouteRoute,
  } as any)
const dashboardDashboardProgramEncountersIndexRoute =
  dashboardDashboardProgramEncountersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardProgramEncountersRoute,
  } as any)
const dashboardDashboardProgramCalendarIndexRoute =
  dashboardDashboardProgramCalendarIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardProgramCalendarRoute,
  } as any)
const dashboardDashboardProgramTodosTabRoute =
  dashboardDashboardProgramTodosTabRouteImport.update({
    id: '/$tab',
    path: '/$tab',
    getParentRoute: () => dashboardDashboardProgramTodosRoute,
  } as any)
const dashboardDashboardProgramSettingsUserProfileRoute =
  dashboardDashboardProgramSettingsUserProfileRouteImport.update({
    id: '/user-profile',
    path: '/user-profile',
    getParentRoute: () => dashboardDashboardProgramSettingsRoute,
  } as any)
const dashboardDashboardProgramPaymentsTabRoute =
  dashboardDashboardProgramPaymentsTabRouteImport.update({
    id: '/$tab',
    path: '/$tab',
    getParentRoute: () => dashboardDashboardProgramPaymentsRoute,
  } as any)
const dashboardDashboardProgramEncountersTabRoute =
  dashboardDashboardProgramEncountersTabRouteImport.update({
    id: '/$tab',
    path: '/$tab',
    getParentRoute: () => dashboardDashboardProgramEncountersRoute,
  } as any)
const dashboardDashboardProgramPatientsPatientIdRoute =
  dashboardDashboardProgramPatientsPatientIdRouteImport.update({
    id: '/patients/patient/$id',
    path: '/patients/patient/$id',
    getParentRoute: () => dashboardDashboardProgramRouteRoute,
  } as any)
const dashboardDashboardProgramEncountersEncounterIdRoute =
  dashboardDashboardProgramEncountersEncounterIdRouteImport.update({
    id: '/encounter/$id',
    path: '/encounter/$id',
    getParentRoute: () => dashboardDashboardProgramEncountersRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/dashboard': typeof dashboardDashboardRouteWithChildren
  '/dashboard/$program': typeof dashboardDashboardProgramRouteRouteWithChildren
  '/reset-password': typeof authAuthResetPasswordRoute
  '/update-password': typeof authAuthUpdatePasswordRoute
  '/urgent-care': typeof authAuthUrgentCareRoute
  '/weight-loss': typeof authAuthWeightLossRoute
  '/': typeof authAuthIndexRoute
  '/dashboard/': typeof dashboardDashboardIndexRoute
  '/success/$type': typeof authAuthSuccessTypeRoute
  '/dashboard/$program/calendar': typeof dashboardDashboardProgramCalendarRouteWithChildren
  '/dashboard/$program/encounters': typeof dashboardDashboardProgramEncountersRouteWithChildren
  '/dashboard/$program/payments': typeof dashboardDashboardProgramPaymentsRouteWithChildren
  '/dashboard/$program/settings': typeof dashboardDashboardProgramSettingsRouteWithChildren
  '/dashboard/$program/todos': typeof dashboardDashboardProgramTodosRouteWithChildren
  '/dashboard/$program/': typeof dashboardDashboardProgramIndexRoute
  '/dashboard/$program/encounters/$tab': typeof dashboardDashboardProgramEncountersTabRoute
  '/dashboard/$program/payments/$tab': typeof dashboardDashboardProgramPaymentsTabRoute
  '/dashboard/$program/settings/user-profile': typeof dashboardDashboardProgramSettingsUserProfileRoute
  '/dashboard/$program/todos/$tab': typeof dashboardDashboardProgramTodosTabRoute
  '/dashboard/$program/calendar/': typeof dashboardDashboardProgramCalendarIndexRoute
  '/dashboard/$program/encounters/': typeof dashboardDashboardProgramEncountersIndexRoute
  '/dashboard/$program/patients/': typeof dashboardDashboardProgramPatientsIndexRoute
  '/dashboard/$program/payments/': typeof dashboardDashboardProgramPaymentsIndexRoute
  '/dashboard/$program/reschedule-booking/': typeof dashboardDashboardProgramRescheduleBookingIndexRoute
  '/dashboard/$program/settings/': typeof dashboardDashboardProgramSettingsIndexRoute
  '/dashboard/$program/todos/': typeof dashboardDashboardProgramTodosIndexRoute
  '/dashboard/$program/encounters/encounter/$id': typeof dashboardDashboardProgramEncountersEncounterIdRoute
  '/dashboard/$program/patients/patient/$id': typeof dashboardDashboardProgramPatientsPatientIdRoute
}
export interface FileRoutesByTo {
  '/reset-password': typeof authAuthResetPasswordRoute
  '/update-password': typeof authAuthUpdatePasswordRoute
  '/urgent-care': typeof authAuthUrgentCareRoute
  '/weight-loss': typeof authAuthWeightLossRoute
  '/': typeof authAuthIndexRoute
  '/dashboard': typeof dashboardDashboardIndexRoute
  '/success/$type': typeof authAuthSuccessTypeRoute
  '/dashboard/$program': typeof dashboardDashboardProgramIndexRoute
  '/dashboard/$program/encounters/$tab': typeof dashboardDashboardProgramEncountersTabRoute
  '/dashboard/$program/payments/$tab': typeof dashboardDashboardProgramPaymentsTabRoute
  '/dashboard/$program/settings/user-profile': typeof dashboardDashboardProgramSettingsUserProfileRoute
  '/dashboard/$program/todos/$tab': typeof dashboardDashboardProgramTodosTabRoute
  '/dashboard/$program/calendar': typeof dashboardDashboardProgramCalendarIndexRoute
  '/dashboard/$program/encounters': typeof dashboardDashboardProgramEncountersIndexRoute
  '/dashboard/$program/patients': typeof dashboardDashboardProgramPatientsIndexRoute
  '/dashboard/$program/payments': typeof dashboardDashboardProgramPaymentsIndexRoute
  '/dashboard/$program/reschedule-booking': typeof dashboardDashboardProgramRescheduleBookingIndexRoute
  '/dashboard/$program/settings': typeof dashboardDashboardProgramSettingsIndexRoute
  '/dashboard/$program/todos': typeof dashboardDashboardProgramTodosIndexRoute
  '/dashboard/$program/encounters/encounter/$id': typeof dashboardDashboardProgramEncountersEncounterIdRoute
  '/dashboard/$program/patients/patient/$id': typeof dashboardDashboardProgramPatientsPatientIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(auth)/_auth': typeof authAuthRouteWithChildren
  '/(dashboard)/dashboard': typeof dashboardDashboardRouteWithChildren
  '/(dashboard)/dashboard/$program': typeof dashboardDashboardProgramRouteRouteWithChildren
  '/(auth)/_auth/reset-password': typeof authAuthResetPasswordRoute
  '/(auth)/_auth/update-password': typeof authAuthUpdatePasswordRoute
  '/(auth)/_auth/urgent-care': typeof authAuthUrgentCareRoute
  '/(auth)/_auth/weight-loss': typeof authAuthWeightLossRoute
  '/(auth)/_auth/': typeof authAuthIndexRoute
  '/(dashboard)/dashboard/': typeof dashboardDashboardIndexRoute
  '/(auth)/_auth/success/$type': typeof authAuthSuccessTypeRoute
  '/(dashboard)/dashboard/$program/calendar': typeof dashboardDashboardProgramCalendarRouteWithChildren
  '/(dashboard)/dashboard/$program/encounters': typeof dashboardDashboardProgramEncountersRouteWithChildren
  '/(dashboard)/dashboard/$program/payments': typeof dashboardDashboardProgramPaymentsRouteWithChildren
  '/(dashboard)/dashboard/$program/settings': typeof dashboardDashboardProgramSettingsRouteWithChildren
  '/(dashboard)/dashboard/$program/todos': typeof dashboardDashboardProgramTodosRouteWithChildren
  '/(dashboard)/dashboard/$program/': typeof dashboardDashboardProgramIndexRoute
  '/(dashboard)/dashboard/$program/encounters/$tab': typeof dashboardDashboardProgramEncountersTabRoute
  '/(dashboard)/dashboard/$program/payments/$tab': typeof dashboardDashboardProgramPaymentsTabRoute
  '/(dashboard)/dashboard/$program/settings/user-profile': typeof dashboardDashboardProgramSettingsUserProfileRoute
  '/(dashboard)/dashboard/$program/todos/$tab': typeof dashboardDashboardProgramTodosTabRoute
  '/(dashboard)/dashboard/$program/calendar/': typeof dashboardDashboardProgramCalendarIndexRoute
  '/(dashboard)/dashboard/$program/encounters/': typeof dashboardDashboardProgramEncountersIndexRoute
  '/(dashboard)/dashboard/$program/patients/': typeof dashboardDashboardProgramPatientsIndexRoute
  '/(dashboard)/dashboard/$program/payments/': typeof dashboardDashboardProgramPaymentsIndexRoute
  '/(dashboard)/dashboard/$program/reschedule-booking/': typeof dashboardDashboardProgramRescheduleBookingIndexRoute
  '/(dashboard)/dashboard/$program/settings/': typeof dashboardDashboardProgramSettingsIndexRoute
  '/(dashboard)/dashboard/$program/todos/': typeof dashboardDashboardProgramTodosIndexRoute
  '/(dashboard)/dashboard/$program/encounters/encounter/$id': typeof dashboardDashboardProgramEncountersEncounterIdRoute
  '/(dashboard)/dashboard/$program/patients/patient/$id': typeof dashboardDashboardProgramPatientsPatientIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/dashboard'
    | '/dashboard/$program'
    | '/reset-password'
    | '/update-password'
    | '/urgent-care'
    | '/weight-loss'
    | '/'
    | '/dashboard/'
    | '/success/$type'
    | '/dashboard/$program/calendar'
    | '/dashboard/$program/encounters'
    | '/dashboard/$program/payments'
    | '/dashboard/$program/settings'
    | '/dashboard/$program/todos'
    | '/dashboard/$program/'
    | '/dashboard/$program/encounters/$tab'
    | '/dashboard/$program/payments/$tab'
    | '/dashboard/$program/settings/user-profile'
    | '/dashboard/$program/todos/$tab'
    | '/dashboard/$program/calendar/'
    | '/dashboard/$program/encounters/'
    | '/dashboard/$program/patients/'
    | '/dashboard/$program/payments/'
    | '/dashboard/$program/reschedule-booking/'
    | '/dashboard/$program/settings/'
    | '/dashboard/$program/todos/'
    | '/dashboard/$program/encounters/encounter/$id'
    | '/dashboard/$program/patients/patient/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/reset-password'
    | '/update-password'
    | '/urgent-care'
    | '/weight-loss'
    | '/'
    | '/dashboard'
    | '/success/$type'
    | '/dashboard/$program'
    | '/dashboard/$program/encounters/$tab'
    | '/dashboard/$program/payments/$tab'
    | '/dashboard/$program/settings/user-profile'
    | '/dashboard/$program/todos/$tab'
    | '/dashboard/$program/calendar'
    | '/dashboard/$program/encounters'
    | '/dashboard/$program/patients'
    | '/dashboard/$program/payments'
    | '/dashboard/$program/reschedule-booking'
    | '/dashboard/$program/settings'
    | '/dashboard/$program/todos'
    | '/dashboard/$program/encounters/encounter/$id'
    | '/dashboard/$program/patients/patient/$id'
  id:
    | '__root__'
    | '/(auth)/_auth'
    | '/(dashboard)/dashboard'
    | '/(dashboard)/dashboard/$program'
    | '/(auth)/_auth/reset-password'
    | '/(auth)/_auth/update-password'
    | '/(auth)/_auth/urgent-care'
    | '/(auth)/_auth/weight-loss'
    | '/(auth)/_auth/'
    | '/(dashboard)/dashboard/'
    | '/(auth)/_auth/success/$type'
    | '/(dashboard)/dashboard/$program/calendar'
    | '/(dashboard)/dashboard/$program/encounters'
    | '/(dashboard)/dashboard/$program/payments'
    | '/(dashboard)/dashboard/$program/settings'
    | '/(dashboard)/dashboard/$program/todos'
    | '/(dashboard)/dashboard/$program/'
    | '/(dashboard)/dashboard/$program/encounters/$tab'
    | '/(dashboard)/dashboard/$program/payments/$tab'
    | '/(dashboard)/dashboard/$program/settings/user-profile'
    | '/(dashboard)/dashboard/$program/todos/$tab'
    | '/(dashboard)/dashboard/$program/calendar/'
    | '/(dashboard)/dashboard/$program/encounters/'
    | '/(dashboard)/dashboard/$program/patients/'
    | '/(dashboard)/dashboard/$program/payments/'
    | '/(dashboard)/dashboard/$program/reschedule-booking/'
    | '/(dashboard)/dashboard/$program/settings/'
    | '/(dashboard)/dashboard/$program/todos/'
    | '/(dashboard)/dashboard/$program/encounters/encounter/$id'
    | '/(dashboard)/dashboard/$program/patients/patient/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  authAuthRoute: typeof authAuthRouteWithChildren
  dashboardDashboardRoute: typeof dashboardDashboardRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(dashboard)/dashboard': {
      id: '/(dashboard)/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof dashboardDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/_auth': {
      id: '/(auth)/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof authAuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(dashboard)/dashboard/': {
      id: '/(dashboard)/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof dashboardDashboardIndexRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(auth)/_auth/': {
      id: '/(auth)/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof authAuthIndexRouteImport
      parentRoute: typeof authAuthRoute
    }
    '/(auth)/_auth/weight-loss': {
      id: '/(auth)/_auth/weight-loss'
      path: '/weight-loss'
      fullPath: '/weight-loss'
      preLoaderRoute: typeof authAuthWeightLossRouteImport
      parentRoute: typeof authAuthRoute
    }
    '/(auth)/_auth/urgent-care': {
      id: '/(auth)/_auth/urgent-care'
      path: '/urgent-care'
      fullPath: '/urgent-care'
      preLoaderRoute: typeof authAuthUrgentCareRouteImport
      parentRoute: typeof authAuthRoute
    }
    '/(auth)/_auth/update-password': {
      id: '/(auth)/_auth/update-password'
      path: '/update-password'
      fullPath: '/update-password'
      preLoaderRoute: typeof authAuthUpdatePasswordRouteImport
      parentRoute: typeof authAuthRoute
    }
    '/(auth)/_auth/reset-password': {
      id: '/(auth)/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof authAuthResetPasswordRouteImport
      parentRoute: typeof authAuthRoute
    }
    '/(dashboard)/dashboard/$program': {
      id: '/(dashboard)/dashboard/$program'
      path: '/$program'
      fullPath: '/dashboard/$program'
      preLoaderRoute: typeof dashboardDashboardProgramRouteRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/dashboard/$program/': {
      id: '/(dashboard)/dashboard/$program/'
      path: '/'
      fullPath: '/dashboard/$program/'
      preLoaderRoute: typeof dashboardDashboardProgramIndexRouteImport
      parentRoute: typeof dashboardDashboardProgramRouteRoute
    }
    '/(dashboard)/dashboard/$program/todos': {
      id: '/(dashboard)/dashboard/$program/todos'
      path: '/todos'
      fullPath: '/dashboard/$program/todos'
      preLoaderRoute: typeof dashboardDashboardProgramTodosRouteImport
      parentRoute: typeof dashboardDashboardProgramRouteRoute
    }
    '/(dashboard)/dashboard/$program/settings': {
      id: '/(dashboard)/dashboard/$program/settings'
      path: '/settings'
      fullPath: '/dashboard/$program/settings'
      preLoaderRoute: typeof dashboardDashboardProgramSettingsRouteImport
      parentRoute: typeof dashboardDashboardProgramRouteRoute
    }
    '/(dashboard)/dashboard/$program/payments': {
      id: '/(dashboard)/dashboard/$program/payments'
      path: '/payments'
      fullPath: '/dashboard/$program/payments'
      preLoaderRoute: typeof dashboardDashboardProgramPaymentsRouteImport
      parentRoute: typeof dashboardDashboardProgramRouteRoute
    }
    '/(dashboard)/dashboard/$program/encounters': {
      id: '/(dashboard)/dashboard/$program/encounters'
      path: '/encounters'
      fullPath: '/dashboard/$program/encounters'
      preLoaderRoute: typeof dashboardDashboardProgramEncountersRouteImport
      parentRoute: typeof dashboardDashboardProgramRouteRoute
    }
    '/(dashboard)/dashboard/$program/calendar': {
      id: '/(dashboard)/dashboard/$program/calendar'
      path: '/calendar'
      fullPath: '/dashboard/$program/calendar'
      preLoaderRoute: typeof dashboardDashboardProgramCalendarRouteImport
      parentRoute: typeof dashboardDashboardProgramRouteRoute
    }
    '/(auth)/_auth/success/$type': {
      id: '/(auth)/_auth/success/$type'
      path: '/success/$type'
      fullPath: '/success/$type'
      preLoaderRoute: typeof authAuthSuccessTypeRouteImport
      parentRoute: typeof authAuthRoute
    }
    '/(dashboard)/dashboard/$program/todos/': {
      id: '/(dashboard)/dashboard/$program/todos/'
      path: '/'
      fullPath: '/dashboard/$program/todos/'
      preLoaderRoute: typeof dashboardDashboardProgramTodosIndexRouteImport
      parentRoute: typeof dashboardDashboardProgramTodosRoute
    }
    '/(dashboard)/dashboard/$program/settings/': {
      id: '/(dashboard)/dashboard/$program/settings/'
      path: '/'
      fullPath: '/dashboard/$program/settings/'
      preLoaderRoute: typeof dashboardDashboardProgramSettingsIndexRouteImport
      parentRoute: typeof dashboardDashboardProgramSettingsRoute
    }
    '/(dashboard)/dashboard/$program/reschedule-booking/': {
      id: '/(dashboard)/dashboard/$program/reschedule-booking/'
      path: '/reschedule-booking'
      fullPath: '/dashboard/$program/reschedule-booking/'
      preLoaderRoute: typeof dashboardDashboardProgramRescheduleBookingIndexRouteImport
      parentRoute: typeof dashboardDashboardProgramRouteRoute
    }
    '/(dashboard)/dashboard/$program/payments/': {
      id: '/(dashboard)/dashboard/$program/payments/'
      path: '/'
      fullPath: '/dashboard/$program/payments/'
      preLoaderRoute: typeof dashboardDashboardProgramPaymentsIndexRouteImport
      parentRoute: typeof dashboardDashboardProgramPaymentsRoute
    }
    '/(dashboard)/dashboard/$program/patients/': {
      id: '/(dashboard)/dashboard/$program/patients/'
      path: '/patients'
      fullPath: '/dashboard/$program/patients/'
      preLoaderRoute: typeof dashboardDashboardProgramPatientsIndexRouteImport
      parentRoute: typeof dashboardDashboardProgramRouteRoute
    }
    '/(dashboard)/dashboard/$program/encounters/': {
      id: '/(dashboard)/dashboard/$program/encounters/'
      path: '/'
      fullPath: '/dashboard/$program/encounters/'
      preLoaderRoute: typeof dashboardDashboardProgramEncountersIndexRouteImport
      parentRoute: typeof dashboardDashboardProgramEncountersRoute
    }
    '/(dashboard)/dashboard/$program/calendar/': {
      id: '/(dashboard)/dashboard/$program/calendar/'
      path: '/'
      fullPath: '/dashboard/$program/calendar/'
      preLoaderRoute: typeof dashboardDashboardProgramCalendarIndexRouteImport
      parentRoute: typeof dashboardDashboardProgramCalendarRoute
    }
    '/(dashboard)/dashboard/$program/todos/$tab': {
      id: '/(dashboard)/dashboard/$program/todos/$tab'
      path: '/$tab'
      fullPath: '/dashboard/$program/todos/$tab'
      preLoaderRoute: typeof dashboardDashboardProgramTodosTabRouteImport
      parentRoute: typeof dashboardDashboardProgramTodosRoute
    }
    '/(dashboard)/dashboard/$program/settings/user-profile': {
      id: '/(dashboard)/dashboard/$program/settings/user-profile'
      path: '/user-profile'
      fullPath: '/dashboard/$program/settings/user-profile'
      preLoaderRoute: typeof dashboardDashboardProgramSettingsUserProfileRouteImport
      parentRoute: typeof dashboardDashboardProgramSettingsRoute
    }
    '/(dashboard)/dashboard/$program/payments/$tab': {
      id: '/(dashboard)/dashboard/$program/payments/$tab'
      path: '/$tab'
      fullPath: '/dashboard/$program/payments/$tab'
      preLoaderRoute: typeof dashboardDashboardProgramPaymentsTabRouteImport
      parentRoute: typeof dashboardDashboardProgramPaymentsRoute
    }
    '/(dashboard)/dashboard/$program/encounters/$tab': {
      id: '/(dashboard)/dashboard/$program/encounters/$tab'
      path: '/$tab'
      fullPath: '/dashboard/$program/encounters/$tab'
      preLoaderRoute: typeof dashboardDashboardProgramEncountersTabRouteImport
      parentRoute: typeof dashboardDashboardProgramEncountersRoute
    }
    '/(dashboard)/dashboard/$program/patients/patient/$id': {
      id: '/(dashboard)/dashboard/$program/patients/patient/$id'
      path: '/patients/patient/$id'
      fullPath: '/dashboard/$program/patients/patient/$id'
      preLoaderRoute: typeof dashboardDashboardProgramPatientsPatientIdRouteImport
      parentRoute: typeof dashboardDashboardProgramRouteRoute
    }
    '/(dashboard)/dashboard/$program/encounters/encounter/$id': {
      id: '/(dashboard)/dashboard/$program/encounters/encounter/$id'
      path: '/encounter/$id'
      fullPath: '/dashboard/$program/encounters/encounter/$id'
      preLoaderRoute: typeof dashboardDashboardProgramEncountersEncounterIdRouteImport
      parentRoute: typeof dashboardDashboardProgramEncountersRoute
    }
  }
}

interface authAuthRouteChildren {
  authAuthResetPasswordRoute: typeof authAuthResetPasswordRoute
  authAuthUpdatePasswordRoute: typeof authAuthUpdatePasswordRoute
  authAuthUrgentCareRoute: typeof authAuthUrgentCareRoute
  authAuthWeightLossRoute: typeof authAuthWeightLossRoute
  authAuthIndexRoute: typeof authAuthIndexRoute
  authAuthSuccessTypeRoute: typeof authAuthSuccessTypeRoute
}

const authAuthRouteChildren: authAuthRouteChildren = {
  authAuthResetPasswordRoute: authAuthResetPasswordRoute,
  authAuthUpdatePasswordRoute: authAuthUpdatePasswordRoute,
  authAuthUrgentCareRoute: authAuthUrgentCareRoute,
  authAuthWeightLossRoute: authAuthWeightLossRoute,
  authAuthIndexRoute: authAuthIndexRoute,
  authAuthSuccessTypeRoute: authAuthSuccessTypeRoute,
}

const authAuthRouteWithChildren = authAuthRoute._addFileChildren(
  authAuthRouteChildren,
)

interface dashboardDashboardProgramCalendarRouteChildren {
  dashboardDashboardProgramCalendarIndexRoute: typeof dashboardDashboardProgramCalendarIndexRoute
}

const dashboardDashboardProgramCalendarRouteChildren: dashboardDashboardProgramCalendarRouteChildren =
  {
    dashboardDashboardProgramCalendarIndexRoute:
      dashboardDashboardProgramCalendarIndexRoute,
  }

const dashboardDashboardProgramCalendarRouteWithChildren =
  dashboardDashboardProgramCalendarRoute._addFileChildren(
    dashboardDashboardProgramCalendarRouteChildren,
  )

interface dashboardDashboardProgramEncountersRouteChildren {
  dashboardDashboardProgramEncountersTabRoute: typeof dashboardDashboardProgramEncountersTabRoute
  dashboardDashboardProgramEncountersIndexRoute: typeof dashboardDashboardProgramEncountersIndexRoute
  dashboardDashboardProgramEncountersEncounterIdRoute: typeof dashboardDashboardProgramEncountersEncounterIdRoute
}

const dashboardDashboardProgramEncountersRouteChildren: dashboardDashboardProgramEncountersRouteChildren =
  {
    dashboardDashboardProgramEncountersTabRoute:
      dashboardDashboardProgramEncountersTabRoute,
    dashboardDashboardProgramEncountersIndexRoute:
      dashboardDashboardProgramEncountersIndexRoute,
    dashboardDashboardProgramEncountersEncounterIdRoute:
      dashboardDashboardProgramEncountersEncounterIdRoute,
  }

const dashboardDashboardProgramEncountersRouteWithChildren =
  dashboardDashboardProgramEncountersRoute._addFileChildren(
    dashboardDashboardProgramEncountersRouteChildren,
  )

interface dashboardDashboardProgramPaymentsRouteChildren {
  dashboardDashboardProgramPaymentsTabRoute: typeof dashboardDashboardProgramPaymentsTabRoute
  dashboardDashboardProgramPaymentsIndexRoute: typeof dashboardDashboardProgramPaymentsIndexRoute
}

const dashboardDashboardProgramPaymentsRouteChildren: dashboardDashboardProgramPaymentsRouteChildren =
  {
    dashboardDashboardProgramPaymentsTabRoute:
      dashboardDashboardProgramPaymentsTabRoute,
    dashboardDashboardProgramPaymentsIndexRoute:
      dashboardDashboardProgramPaymentsIndexRoute,
  }

const dashboardDashboardProgramPaymentsRouteWithChildren =
  dashboardDashboardProgramPaymentsRoute._addFileChildren(
    dashboardDashboardProgramPaymentsRouteChildren,
  )

interface dashboardDashboardProgramSettingsRouteChildren {
  dashboardDashboardProgramSettingsUserProfileRoute: typeof dashboardDashboardProgramSettingsUserProfileRoute
  dashboardDashboardProgramSettingsIndexRoute: typeof dashboardDashboardProgramSettingsIndexRoute
}

const dashboardDashboardProgramSettingsRouteChildren: dashboardDashboardProgramSettingsRouteChildren =
  {
    dashboardDashboardProgramSettingsUserProfileRoute:
      dashboardDashboardProgramSettingsUserProfileRoute,
    dashboardDashboardProgramSettingsIndexRoute:
      dashboardDashboardProgramSettingsIndexRoute,
  }

const dashboardDashboardProgramSettingsRouteWithChildren =
  dashboardDashboardProgramSettingsRoute._addFileChildren(
    dashboardDashboardProgramSettingsRouteChildren,
  )

interface dashboardDashboardProgramTodosRouteChildren {
  dashboardDashboardProgramTodosTabRoute: typeof dashboardDashboardProgramTodosTabRoute
  dashboardDashboardProgramTodosIndexRoute: typeof dashboardDashboardProgramTodosIndexRoute
}

const dashboardDashboardProgramTodosRouteChildren: dashboardDashboardProgramTodosRouteChildren =
  {
    dashboardDashboardProgramTodosTabRoute:
      dashboardDashboardProgramTodosTabRoute,
    dashboardDashboardProgramTodosIndexRoute:
      dashboardDashboardProgramTodosIndexRoute,
  }

const dashboardDashboardProgramTodosRouteWithChildren =
  dashboardDashboardProgramTodosRoute._addFileChildren(
    dashboardDashboardProgramTodosRouteChildren,
  )

interface dashboardDashboardProgramRouteRouteChildren {
  dashboardDashboardProgramCalendarRoute: typeof dashboardDashboardProgramCalendarRouteWithChildren
  dashboardDashboardProgramEncountersRoute: typeof dashboardDashboardProgramEncountersRouteWithChildren
  dashboardDashboardProgramPaymentsRoute: typeof dashboardDashboardProgramPaymentsRouteWithChildren
  dashboardDashboardProgramSettingsRoute: typeof dashboardDashboardProgramSettingsRouteWithChildren
  dashboardDashboardProgramTodosRoute: typeof dashboardDashboardProgramTodosRouteWithChildren
  dashboardDashboardProgramIndexRoute: typeof dashboardDashboardProgramIndexRoute
  dashboardDashboardProgramPatientsIndexRoute: typeof dashboardDashboardProgramPatientsIndexRoute
  dashboardDashboardProgramRescheduleBookingIndexRoute: typeof dashboardDashboardProgramRescheduleBookingIndexRoute
  dashboardDashboardProgramPatientsPatientIdRoute: typeof dashboardDashboardProgramPatientsPatientIdRoute
}

const dashboardDashboardProgramRouteRouteChildren: dashboardDashboardProgramRouteRouteChildren =
  {
    dashboardDashboardProgramCalendarRoute:
      dashboardDashboardProgramCalendarRouteWithChildren,
    dashboardDashboardProgramEncountersRoute:
      dashboardDashboardProgramEncountersRouteWithChildren,
    dashboardDashboardProgramPaymentsRoute:
      dashboardDashboardProgramPaymentsRouteWithChildren,
    dashboardDashboardProgramSettingsRoute:
      dashboardDashboardProgramSettingsRouteWithChildren,
    dashboardDashboardProgramTodosRoute:
      dashboardDashboardProgramTodosRouteWithChildren,
    dashboardDashboardProgramIndexRoute: dashboardDashboardProgramIndexRoute,
    dashboardDashboardProgramPatientsIndexRoute:
      dashboardDashboardProgramPatientsIndexRoute,
    dashboardDashboardProgramRescheduleBookingIndexRoute:
      dashboardDashboardProgramRescheduleBookingIndexRoute,
    dashboardDashboardProgramPatientsPatientIdRoute:
      dashboardDashboardProgramPatientsPatientIdRoute,
  }

const dashboardDashboardProgramRouteRouteWithChildren =
  dashboardDashboardProgramRouteRoute._addFileChildren(
    dashboardDashboardProgramRouteRouteChildren,
  )

interface dashboardDashboardRouteChildren {
  dashboardDashboardProgramRouteRoute: typeof dashboardDashboardProgramRouteRouteWithChildren
  dashboardDashboardIndexRoute: typeof dashboardDashboardIndexRoute
}

const dashboardDashboardRouteChildren: dashboardDashboardRouteChildren = {
  dashboardDashboardProgramRouteRoute:
    dashboardDashboardProgramRouteRouteWithChildren,
  dashboardDashboardIndexRoute: dashboardDashboardIndexRoute,
}

const dashboardDashboardRouteWithChildren =
  dashboardDashboardRoute._addFileChildren(dashboardDashboardRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  authAuthRoute: authAuthRouteWithChildren,
  dashboardDashboardRoute: dashboardDashboardRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
